import { render, staticRenderFns } from "./Emphasis.vue?vue&type=template&id=1171d91e"
import script from "./Emphasis.vue?vue&type=script&lang=js"
export * from "./Emphasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports